/*****************************************
VANILLA JS - LOAD EVENTS
******************************************/

// functions for run events after page loaded , async load scripts, and events with conditions (scroll, click, etc)
function _checkafterLoadEvents() {
  window.afterLoadWithEvents.forEach(x => {
    const isDocument = x.el === document;
    if (x.evt && !isDocument) {
      if (
        x.evt === arguments[0].type &&
        x.el === arguments[0].target
        ) {
        x.el.removeEventListener(x.evt, _checkafterLoadEvents);
        if (typeof (x.f) == 'function') {
          setTimeout(x.f, 0);
        }
        else {
          window[x.f].apply();
        }
        window.afterLoadWithEvents.splice(window.afterLoadWithEvents.indexOf(x), 1);
      }
    }
    else {
      if (typeof (x.f) == 'function') {
        setTimeout(x.f, 0);
      }
      else {
        window[x.f].apply();
      }
      window.afterLoadWithEvents.splice(window.afterLoadWithEvents.indexOf(x), 1);
    }
  });
  if (window.afterLoadWithEvents.length == 0) {
    window.removeEventListener('scroll', _checkafterLoadEvents);
  }
}

function register() {
  const htmlElement = document.documentElement;
  htmlElement.classList.remove('no-js');
  htmlElement.classList.add('js');

  if (window.ReadyScript) {
    window.ReadyScript.forEach(x => {
      loadScript(x.s, x.c);
    });
  }
  if (window.afterLoad) {
    window.afterLoad.forEach(x => {
      if (x.p != undefined) {
        window[x.f].apply(x.p);
      } else {
        window[x.f].apply();
      }
    });
  }

  if (window.afterLoadWithEvents) {
    window.addEventListener('scroll', _checkafterLoadEvents);
    window.afterLoadWithEvents.forEach(x => {
      if (x.evt) {
        x.el.addEventListener(x.evt, _checkafterLoadEvents);
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", () => register());

// Load scripts after page load

function loadScript(sc, callback) {
  if (Array.isArray(sc)) {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = sc[0];
    sc.splice(0, 1);
    if (sc.length > 0) {
      script.addEventListener("load", () => loadScript(sc, callback));
    } else if (callback !== undefined) {
      script.addEventListener("load", () => {
        window[callback].apply();
      });
    }
    document.body.appendChild(script);
  } else {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = sc;

    if (callback !== undefined) {
      script.addEventListener("load", () => {
        window[callback].apply();
      });
    }
    document.body.appendChild(script);
  }
}

/*****************************************
VANILLA JS - HELPER FUNCTIONS
******************************************/
function fadeIn(el, displayValue, delay) {
  clearTimeout(el._fadeTimeout);
  el._fadeTimeout = setTimeout(() => {
    el.style.display = displayValue;
    el.style.visibility = 'visible';
    el.style.opacity = '0';
    el.style.transition = 'opacity 400ms';
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        el.style.opacity = '1';
      });
    });
  }, delay);
}

function fadeOut(el, delay) {
  clearTimeout(el._fadeTimeout);
  el._fadeTimeout = setTimeout(() => {
    el.style.transition = 'opacity 400ms';
    el.style.opacity = '0';
    el._transitionTimeout = setTimeout(() => {
      el.style.display = 'none';
      el.style.visibility = 'hidden';
    }, 400);
  }, delay);
}

function stopFade(el, jumpToEnd) {
  clearTimeout(el._fadeTimeout);
  clearTimeout(el._transitionTimeout);
  el.style.transition = 'none';
  if (jumpToEnd) {
    // leave as-is; caller decides next state
  }
}

let slideUp = (el, duration = 400) => {
  if (!el._sliding) el._sliding = true;

  el.style.height = el.offsetHeight + 'px';
  el.style.transitionProperty = 'height, margin, padding';
  el.style.transitionDuration = duration + 'ms';
  el.offsetHeight; // force reflow

  el.style.overflow = 'hidden';
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;

  window.setTimeout(() => {
    el.style.display = 'none';
    el.style.removeProperty('height');
    el.style.removeProperty('padding-top');
    el.style.removeProperty('padding-bottom');
    el.style.removeProperty('margin-top');
    el.style.removeProperty('margin-bottom');
    el.style.removeProperty('overflow');
    el.style.removeProperty('transition-duration');
    el.style.removeProperty('transition-property');
    el._sliding = false;
  }, duration);
};

let slideDown = (el, duration = 400) => {
  if (!el._sliding) el._sliding = true;
  el.style.display = 'block';  // set this FIRST before anything else
  let height = el.scrollHeight;
  el.style.overflow = 'hidden';
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  el.offsetHeight; // force reflow
  el.style.transitionProperty = 'height, margin, padding';
  el.style.transitionDuration = duration + 'ms';
  el.style.height = height + 'px';
  el.style.removeProperty('padding-top');
  el.style.removeProperty('padding-bottom');
  el.style.removeProperty('margin-top');
  el.style.removeProperty('margin-bottom');
  window.setTimeout(() => {
    el.style.removeProperty('height');
    el.style.removeProperty('overflow');
    el.style.removeProperty('transition-duration');
    el.style.removeProperty('transition-property');
    el._sliding = false;
  }, duration);
};

let slideToggle = (el, duration = 400) => {
  if (window.getComputedStyle(el).display === 'none') {
    slideDown(el, duration);
  } else {
    slideUp(el, duration);
  }
};

// Show Loader
function loader(isShow) {
  const loaderEl = document.querySelector('.loader');
  if (loaderEl) loaderEl.style.display = isShow ? 'block' : 'none';
}

/******************************************
VANILLA JS - ACCORDION
******************************************/
function initAccordion(selector, options = {}) {
  const titles = document.querySelectorAll(selector);
  const duration = options.duration || 400;
  const allowMultiple = options.allowMultiple || false; // open multiple panels if true

  titles.forEach(title => {
    title.addEventListener('click', handleAccordion);
    title.addEventListener('keypress', handleAccordion);
  });

  function handleAccordion(event) {
    if (event.type !== 'click' && !(event.type === 'keypress' && (event.key === 'Enter' || event.keyCode === 13))) return;

    const panel = event.currentTarget.nextElementSibling;

    if (!allowMultiple) {
      // Close all other panels
      titles.forEach(t => {
        const p = t.nextElementSibling;
        if (t !== event.currentTarget && t.classList.contains('active')) {
          if (!p._sliding) slideUp(p, duration);
          t.classList.remove('active');
          t.setAttribute('aria-expanded', 'false');
        }
      });
    }

    // Toggle current panel
    if (!panel._sliding) {
      if (event.currentTarget.classList.contains('active')) {
        slideUp(panel, duration);
        event.currentTarget.classList.remove('active');
        event.currentTarget.setAttribute('aria-expanded', 'false');
      } else {
        slideDown(panel, duration);
        event.currentTarget.classList.add('active');
        event.currentTarget.setAttribute('aria-expanded', 'true');
      }
    }
  }
}
initAccordion('.faqs-accordion__title', { duration: 400, allowMultiple: false });
initAccordion('.product-accordion__title', { duration: 400, allowMultiple: false });
initAccordion('.footer-content__accordion-header', { duration: 400, allowMultiple: true });

/******************************************
VANILLA JS - ACCOUNT TABS
******************************************/
document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.account .tab');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const tabId = tab.getAttribute('data-tab');

      // Remove active class from all tabs
      tabs.forEach(t => t.classList.remove('account__tab--active'));

      // Hide all tab content
      document.querySelectorAll('.account__content').forEach(content => {
        content.style.display = 'none';
      });

      // Activate clicked tab
      tab.classList.add('account__tab--active');

      // Show the corresponding content
      const activeContent = document.getElementById(tabId);
      if (activeContent) {
        activeContent.style.display = '';
      }
    });
  });
});

/******************************************
VANILLA JS - CANVAS CART
******************************************/
(function () {

  var canvasCart = document.querySelector('.canvas-cart');
  var canvasContent = document.querySelector('.c-offcanvas-content-wrap');
  var canvasOverlay = document.querySelector('.c-offcanvas-bg');
  var triggers = document.querySelectorAll('.js-offcanvas-trigger-left, [data-offcanvas-trigger]');
  var closebtns = document.querySelectorAll('.js-offcanvas-close');

  if (!canvasCart) return;

  function openCart() {
    canvasCart.classList.remove('is-closed');
    canvasCart.classList.add('is-open');
    if (canvasOverlay) { canvasOverlay.classList.remove('is-closed'); canvasOverlay.classList.add('is-open'); }
    if (canvasContent) canvasContent.classList.add('is-open', 'c-offcanvas-content-wrap--right', 'c-offcanvas-content-wrap--overlay');
    document.documentElement.classList.add('has-offcanvas--visible');
  }

  function closeCart() {
    canvasCart.classList.remove('is-open');
    if (canvasOverlay) {
      canvasOverlay.classList.remove('is-open');
      canvasOverlay.classList.add('is-animating', 'c-offcanvas-bg--closing');
    }
    if (canvasContent) canvasContent.classList.remove('is-open', 'c-offcanvas-content-wrap--right', 'c-offcanvas-content-wrap--overlay');
    document.documentElement.classList.remove('has-offcanvas--visible');

    setTimeout(function() {
      canvasCart.classList.add('is-closed');
      if (canvasOverlay) {
        canvasOverlay.classList.remove('is-animating', 'c-offcanvas-bg--closing');
        canvasOverlay.classList.add('is-closed');
      }
    }, 500);
  }

  function toggleCart() {
    canvasCart.classList.contains('is-open') ? closeCart() : openCart();
  }

  // Trigger buttons (open/toggle)
  triggers.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      toggleCart();
    });
  });

  // Close buttons
  closebtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      closeCart();
    });
  });

  // Close on overlay click (clicks outside the cart panel itself)
  document.addEventListener('click', function (e) {
    if (
      canvasCart.classList.contains('is-open') &&
      !canvasCart.contains(e.target) &&
      !e.target.closest('.js-offcanvas-trigger-left, [data-offcanvas-trigger]')
    ) {
      closeCart();
    }
  });

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  // Shim for ajaxify.js
  window.dataOffcanvas = {
    toggle: toggleCart,
    open:   openCart,
    close:  closeCart
  };

})();

/******************************************
VANILLA JS - CART DISCOUNT
******************************************/
function updateCartDiscount(discountCode) {
  const cartId=getCookie('cart') ? `gid://shopify/Cart/${getCookie('cart')}` : '';
  if (cartId != '' )  {
    const _var={
      cartId:cartId,
      discountCodes:discountCode
    };
    FetchDataWithVariables(`
      mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
        cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
          cart {
            id
            discountCodes {
              code
            }
          }
          userErrors {
            field
            message
          }
        }
      }
      `,_var,function(data) {
        _updateCartContent(discountCode!=''?true:false);
      }
    );
  }
}
document.querySelectorAll('[data-action="discountcode"]').forEach(element => {
  element.addEventListener('click',function() {
    updateCartDiscount(document.querySelector('[data-discountcode]').value);
  });
});
document.querySelectorAll('[data-action="discountremove"]').forEach(element => {
  element.addEventListener('click',function() {
    updateCartDiscount('');
    const discountInput = document.getElementById('discount'); // or querySelector
    if (discountInput) discountInput.value = '';
  });
});

/******************************************
VANILLA JS - COLLECTION INTRO TOGGLE
******************************************/
document.addEventListener('DOMContentLoaded', () => {
  const toggleButtons = document.querySelectorAll('.collection__toggle');

  toggleButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault(); // prevent default link behavior

      // Toggle the visibility class on the description content
      const content = document.querySelector('.collection__description-content');
      if (content) {
        content.classList.toggle('collection__description-content--visible');
      }
    });
  });
});

/******************************************
VANILLA JS - COOKIE FUNCTION
******************************************/
// Cookie Set
function setCookie(cname,cvalue) {
  var d = new Date();
  d.setTime(d.getTime() + (365*24*60*60*1000));
  var expires = "expires=" + d.toGMTString();
  if((typeof cvalue)!="string")   var cvalue_string=JSON.stringify(cvalue);
  else var cvalue_string=cvalue;
  document.cookie = cname + "=" + cvalue_string + ";" + expires + ";path=/";
}

// Cookie Get
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  } 
}

/******************************************
VANILLA JS - CURRENCY CONVERTER
******************************************/
document.addEventListener('DOMContentLoaded', () => {
  const currencySelects = document.querySelectorAll('.shopify-currency-form select');

  currencySelects.forEach(select => {
    select.addEventListener('change', () => {
      const form = select.closest('form');
      if (form) form.submit();
    });
  });
});

/******************************************
VANILLA JS - FINANCE POPUPS
******************************************/
function initFinancePopups() {
  const html = document.documentElement;

  function openPopup(type) {
    const popup = document.getElementById(`finance-popup-${type}`);
    if (!popup) return;
    // Close any open popup first
    closeAllPopups();
    popup.classList.add('product-finance-popup--active');
    html.classList.add('noscroll-finance-popup');
  }

  function closeAllPopups() {
    document.querySelectorAll('.product-finance-popup--active').forEach(popup => {
      popup.classList.remove('product-finance-popup--active');
    });
    html.classList.remove('noscroll-finance-popup');
  }

  // Handle ALL clicks in one listener (event delegation)
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-finance-popup]');
    const closeBtn = e.target.closest('[data-finance-close]');
    const activePopup = document.querySelector('.product-finance-popup--active');
    // Open
    if (trigger) {
      const type = trigger.getAttribute('data-finance-popup');
      openPopup(type);
      return;
    }
    // Close via button
    if (closeBtn) {
      closeAllPopups();
      return;
    }
    // Close on overlay click ONLY
    if (
      activePopup &&
      e.target.closest('.product-finance-popup') && // clicked inside overlay
      !e.target.closest('.product-finance-popup__popup') // but NOT inside panel
    ) {
      closeAllPopups();
    }
  });

  // ESC key support (bonus UX)
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeAllPopups();
    }
  });
}
initFinancePopups();

/******************************************
VANILLA JS - HEADER STICKY
******************************************/
let previousScroll = 0;
let headerOrgOffset = 0;
const header = document.querySelector('.header');

if (header) headerOrgOffset = header.getBoundingClientRect().top + window.scrollY;

window.addEventListener('scroll', function () {
  if (header) {
    const currentScroll = window.scrollY;
    const isNoScroll = document.documentElement.classList.contains('no-scroll');

    if (!isNoScroll) {
      if (currentScroll > headerOrgOffset) {
        if (currentScroll > previousScroll) {
          header.classList.remove('header--sticky');
        } else {
          header.classList.add('header--sticky');
        }
      } else {
        header.classList.remove('header--sticky');
      }
    }

    previousScroll = currentScroll;
  }
});

/******************************************
VANILLA JS - LAZYLOAD
******************************************/
document.addEventListener('lazybeforeunveil', function (e) {
  var bg = e.target.getAttribute('data-bg');
  if (bg) {
    e.target.style.backgroundImage = "url('" + bg + "')";
  }
});

/******************************************
VANILLA JS - LIGHTGALLERY
******************************************/
// LightGallery Popup - Product Page
const lightgalleryEl = document.getElementById('lightgallery');
if (lightgalleryEl) {
  lightGallery(lightgalleryEl, {
    selector: '.product-images__item-image',
    plugins: [lgZoom, lgThumbnail],
    speed: 500,
    thumbnail: false,
    getCaptionFromTitleOrAlt: false,
    licenseKey: 'C1DB9144-799D4957-B3C1226F-C451F4A3',
    mobileSettings: {
      controls: true,
      showCloseIcon: true,
      download: false,
    }
  });
}

// LightGallery Popup - Gallery Page 
const lightgallerypageEl = document.getElementById('lightgallerypage');
if (lightgallerypageEl) {
  lightGallery(lightgallerypageEl, {
    selector: '.gallery__image-link',
    plugins: [lgZoom, lgThumbnail],
    speed: 500,
    thumbnail: false,
    getCaptionFromTitleOrAlt: true,
    licenseKey: 'C1DB9144-799D4957-B3C1226F-C451F4A3',
    mobileSettings: {
      controls: true,
      showCloseIcon: true,
      download: false,
    }
  });
}

/******************************************
VANILLA JS - MEGA NAV
******************************************/

// Set initial display types but keep hidden
document.querySelectorAll(".nav__mega .nav__sub-menu").forEach(el => {
  el.style.display = 'flex';
  el.style.opacity = '0';
  el.style.display = 'none';
});
document.querySelectorAll(".nav__single .nav__sub-menu").forEach(el => {
  el.style.display = 'block';
  el.style.opacity = '0';
  el.style.display = 'none';
});

// Store display value per element before hiding
function getDisplayValue(el) {
  if (el.closest(".nav__mega")) return 'flex';
  return 'block';
}

const navOverlay = document.querySelector('.nav-overlay');

document.querySelectorAll(".nav__dropdown").forEach(dropdown => {
  dropdown.addEventListener("mouseenter", () => {
    if (window.innerWidth > 1279) {
      const subMenu = dropdown.querySelector(":scope > .nav__sub-menu");
      const spans = dropdown.querySelectorAll(":scope > .nav__link > span");

      if (navOverlay) { stopFade(navOverlay); fadeIn(navOverlay, 'block', 250); }
      if (subMenu) { stopFade(subMenu); fadeIn(subMenu, getDisplayValue(subMenu), 250); }
      spans.forEach(span => { stopFade(span); fadeIn(span, 'inline', 250); });
    }
  });

  dropdown.addEventListener("mouseleave", () => {
    if (window.innerWidth > 1279) {
      const subMenu = dropdown.querySelector(":scope > .nav__sub-menu");
      const spans = dropdown.querySelectorAll(":scope > .nav__link > span");

      if (navOverlay) { stopFade(navOverlay); fadeOut(navOverlay, 250); }
      if (subMenu) { stopFade(subMenu); fadeOut(subMenu, 250); }
      spans.forEach(span => { stopFade(span); fadeOut(span, 250); });
    }
  });
});

// Keyboard interaction - only open on Enter
document.querySelectorAll(".nav__dropdown .nav__link").forEach(link => {
  link.addEventListener("keydown", (e) => {
    if (e.key === "Enter") {
      const dropdown = link.closest(".nav__dropdown");
      const subMenu = dropdown ? dropdown.querySelector(":scope > .nav__sub-menu") : null;

      if (subMenu) {
        const isVisible = subMenu.style.display !== 'none' && subMenu.style.opacity !== '0';

        // Close all other open submenus and overlay first
        document.querySelectorAll(".nav__dropdown").forEach(otherDropdown => {
          if (otherDropdown !== dropdown) {
            const otherSubMenu = otherDropdown.querySelector(":scope > .nav__sub-menu");
            const otherSpans = otherDropdown.querySelectorAll(":scope > .nav__link > span");
            if (otherSubMenu) { stopFade(otherSubMenu); fadeOut(otherSubMenu, 0); }
            otherSpans.forEach(span => { stopFade(span); fadeOut(span, 0); });
          }
        });

        if (isVisible) {
          stopFade(subMenu);
          fadeOut(subMenu, 0);
          if (navOverlay) { stopFade(navOverlay); fadeOut(navOverlay, 0); }
        } else {
          stopFade(subMenu);
          fadeIn(subMenu, getDisplayValue(subMenu), 0);
          if (navOverlay) { stopFade(navOverlay); fadeIn(navOverlay, 'block', 0); }
        }
      }

      e.preventDefault();
    }
  });
});

/******************************************
VANILLA JS - MOBILE NAV
******************************************/
document.addEventListener('DOMContentLoaded', function () {

  // Remove inline display: none set by Shopify
  const headerNav = document.querySelector('.header-nav');
  if (headerNav) headerNav.style.display = '';

  // Clone
  document.querySelectorAll('.nav__sub-menu').forEach(function (menu) {
    const clone = menu.cloneNode(true);
    clone.classList.add('nav__sub-menu--cloned');
    const wrap = document.createElement('div');
    wrap.classList.add('nav__sub-menu__wrap');
    while (clone.firstChild) wrap.appendChild(clone.firstChild);
    clone.appendChild(wrap);
    document.querySelector('.header-nav').insertAdjacentElement('afterend', clone);
  });

  // Open & Close Nav (Mobile) - Click Function
  const headerMobile = document.querySelector('.header-mobile');
  if (headerMobile) {
    headerMobile.addEventListener('click', function () {
      const overlay = document.querySelector('.mobile-nav-overlay');
      this.classList.toggle('header-mobile--active');
      document.querySelector('.header-announcements')?.classList.toggle('header-announcements--hide');
      document.querySelector('.header-nav')?.classList.toggle('header-nav--active');
      document.documentElement.classList.toggle('no-scroll-mobile-nav');
      overlay.style.display = overlay.style.display === 'none' ? 'block' : 'none';
      document.querySelectorAll('.nav__sub-menu--cloned').forEach(el => el.classList.remove('nav__sub-menu--active'));
      document.querySelectorAll('.nav').forEach(el => el.classList.remove('nav--hidden'));
    });
  }

  // Close Nav (Mobile) - Click Function
  const overlay = document.querySelector('.mobile-nav-overlay');
  if (overlay) {
    overlay.addEventListener('click', function () {
      document.querySelector('.header-mobile')?.classList.remove('header-mobile--active');
      document.querySelector('.header-announcements')?.classList.remove('header-announcements--hide');
      document.querySelector('.header-nav')?.classList.remove('header-nav--active');
      document.documentElement.classList.remove('no-scroll-mobile-nav');
      this.style.display = 'none';
      document.querySelectorAll('.nav').forEach(el => el.classList.remove('nav--hidden'));
      document.querySelectorAll('.nav__sub-menu--cloned').forEach(el => el.classList.remove('nav__sub-menu--active'));
    });
  }

  // Open Sub Menu - Click Function
  document.querySelectorAll('.nav__dropdown .nav__link').forEach(function (link) {
    link.addEventListener('click', function (event) {
      if (window.innerWidth < 1280) {
        event.preventDefault();
      }
      const id = this.getAttribute('id');
      document.querySelectorAll('.nav__sub-menu').forEach(function (menu) {
        const dataid = menu.getAttribute('data-id');
        console.log(dataid);
        if (id === dataid) {
          menu.classList.add('nav__sub-menu--active');
        }
      });
      document.querySelectorAll('.nav').forEach(el => el.classList.add('nav--hidden'));
    });
  });

  // Back Button - Click Function
  document.querySelectorAll('.nav__sub-menu__back').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.nav__sub-menu').forEach(el => el.classList.remove('nav__sub-menu--active'));
      document.querySelectorAll('.nav').forEach(el => el.classList.remove('nav--hidden'));
    });
  });

});

/******************************************
VANILLA JS - MOBILE SEARCH TOGGLE
******************************************/
document.addEventListener('DOMContentLoaded', function () {

  const form = document.querySelector('.header-search__form');
  const siteContainer = document.querySelector('.site-container');

  document.querySelectorAll('.header-search__toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      form?.classList.toggle('header-search__form--visible');
      siteContainer?.classList.toggle('site-container--blackout');
      document.querySelector('.header-search__input')?.focus();
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.header-search')) {
      siteContainer?.classList.remove('site-container--blackout');
      form?.classList.remove('header-search__form--visible');
    }
  });

});

/******************************************
VANILLA JS - PRODUCT CARD SWATCHES
******************************************/

// Swatch Hover Function (Metaobject Method)
function showSwatchData(e,t) {
  const swatch = t!='click'?e.target:e.target.closest('a.swatches__col');
  const productCard = swatch.closest('.product-card');
  const productImage = productCard.querySelector('.product-card__image');
  const productTitle = productCard.querySelector('.product-card__title');
  const productPrice = productCard.querySelector('.product-card__price-current');
  const productComparePrice = productCard.querySelector('.product-card__price-compare');
  const productLink = productCard.querySelector('.product-card__image-link');
  const titleLink = productCard.querySelector('.product-card__title');
  const savingText = productCard.querySelector('.product-card__price-saving');
  const priceContainer = productCard.querySelector('.product-card__price');
  const overlayContainer = productCard.querySelector('.product-card__overlays');
  const ds = t=='mouseenter'?swatch.dataset:(t=='mouseleave'?productCard.dataset:e.target.closest('a.swatches__col').dataset);

  if (t!='click' || !productLink.href.endsWith(ds.productUrl)) {
    e.preventDefault();
  }
  // Update with swatch data
  if (ds.imageUrl) {
    productImage.src = ds.imageUrl;
    productImage.srcset = ds.imageSrcset || '';
  }
  
  if (ds.title) {
    productTitle.textContent = ds.title;
    productTitle.title = ds.title;
  }
  
  if (ds.price) {
    productPrice.textContent = ds.price;
  }

  if (ds.comparePrice && ds.onSale === 'true') {
    savingText.textContent = ds.saving;
    savingText.style.display = 'inline';
  } else {
    savingText.style.display = 'none';
  }
  
  // Handle compare price and sale state
  if (ds.comparePrice && ds.onSale === 'true') {
    productComparePrice.textContent = ds.comparePrice;
    productComparePrice.style.display = 'inline';
    priceContainer.classList.add('product-card__price--on-sale');
  } else {
    productComparePrice.style.display = 'none';
    priceContainer.classList.remove('product-card__price--on-sale');
  }
  
  // Handle overlay
  if (ds.overlays) {
    overlayContainer.innerHTML = ds.overlays;
  } else {
    overlayContainer.innerHTML = "";
  }
  
  // Update links
  if (ds.productUrl) {
    productLink.href = ds.productUrl;
    titleLink.href = ds.productUrl;
  }  
}

// Swatch Hover Output (Metaobject Method)
document.addEventListener('DOMContentLoaded', function() {
  
  // Desktop Hover
  document.addEventListener('mouseenter', function(e) {
    if (window.innerWidth>1279 && e.target && e.target.classList && e.target.classList.contains('swatches__col') && e.target.closest('.product-card__swatches')) {        
      showSwatchData(e,'mouseenter');        
    }
  }, true);
  document.addEventListener('mouseleave', function(e) {
    if (window.innerWidth>1279 && e.target && e.target.classList && e.target.classList.contains('swatches__col') && e.target.closest('.product-card__swatches')) {        
      showSwatchData(e,'mouseleave');  
    }
  }, true);

  // Tablet & Mobile Click
  document.addEventListener('click', function(e) {
    if (window.innerWidth < 1280 && e.target && e.target.closest('a.swatches__col') && e.target.closest('.product-card__swatches')) {
      const swatchCol = e.target.closest('a.swatches__col');
      const swatchContainer = swatchCol.closest('.product-card__swatches');

      swatchContainer.querySelectorAll('.swatches__swatch--current').forEach(function(el) {
        el.classList.remove('swatches__swatch--current');
      });

      const swatch = swatchCol.querySelector('.swatches__swatch');
      if (swatch) {
        swatch.classList.add('swatches__swatch--current');
      }

      showSwatchData(e, 'click');
    }
  }, true);

  // Reset on resize
  window.addEventListener('resize', function() {
    if (window.innerWidth >= 1280) {
      document.querySelectorAll('.product-card').forEach(function(card) {
        const swatchContainer = card.querySelector('.product-card__swatches');
        const firstSwatchCol = swatchContainer?.querySelector('a.swatches__col');
        const firstSwatch = firstSwatchCol?.querySelector('.swatches__swatch');

        if (!firstSwatchCol || !firstSwatch) return;

        swatchContainer.querySelectorAll('.swatches__swatch--current').forEach(function(el) {
          el.classList.remove('swatches__swatch--current');
        });

        firstSwatch.classList.add('swatches__swatch--current');

        const fakeEvent = { target: firstSwatchCol, preventDefault: function(){} };
        showSwatchData(fakeEvent, 'click');
      });
    }
  });
});

/******************************************
VANILLA JS - SWIPER SLIDER
******************************************/

// Swiper Slider - Default
if (document.querySelectorAll('.swiper--default').length > 0) {
  initSwipers();
}
var productImagesSwiper;
function initSwipers() {
  const swiperInstances = [];

  document.querySelectorAll('.swiper--default').forEach((el, index) => {
    if (el.classList.contains('swiper-initialized')) return;

    el.classList.add('swiper-' + index);

    const pagination = el.querySelector('.swiper-pagination');
    const buttonPrev = el.querySelector('.swiper-button-prev');
    const buttonNext = el.querySelector('.swiper-button-next');
    const scrollbar  = el.querySelector('.swiper-scrollbar');

    if (pagination) pagination.classList.add('pagination-' + index);
    if (buttonPrev) buttonPrev.classList.add('prev-' + index);
    if (buttonNext) buttonNext.classList.add('next-' + index);
    if (scrollbar)  scrollbar.classList.add('scrollbar-' + index);

    const $autoplay  = el.classList.contains('swiper--autoplay') ? { delay: 4000 } : false;
    const $freemode  = !el.classList.contains('swiper--snap');
    const $centre    = !el.classList.contains('swiper--left');

    const $pagination      = pagination ? '.pagination-' + index : null;
    const $pagination_type = el.querySelector('.swiper-pagination--fraction') ? 'fraction' : 'bullets';
    const $next            = buttonNext ? '.next-' + index : null;
    const $prev            = buttonPrev ? '.prev-' + index : null;
    const $scrollbar       = scrollbar  ? '.scrollbar-' + index : null;

    swiperInstances[index] = new Swiper('.swiper-' + index, {
      autoplay: $autoplay,
      slidesPerView: 'auto',
      centerInsufficientSlides: $centre,
      navigation: {
        prevEl: $prev,
        nextEl: $next,
      },
      pagination: {
        el: $pagination,
        type: $pagination_type,
        clickable: true,
      },
      scrollbar: {
        el: $scrollbar,
        draggable: true,
        snapOnRelease: false,
      },
      mousewheel: {
        forceToAxis: true,
      },
      freeMode: {
        enabled: $freemode,
        minimumVelocity: 0,
        momentumBounce: false,
        momentumRatio: 0.5,
        momentumVelocityRatio: 1.5,
      },
    });
  });

  setTimeout(() => {
    swiperInstances.forEach(slider => {
      if (!slider) return;

      slider.update();

      const navEl = slider.el.querySelector('.swiper-nav');

      if (slider.isLocked && navEl) {
        navEl.classList.add('swiper-nav--locked');
      }

      slider.on('lock', () => {
        const nav = slider.el.querySelector('.swiper-nav');
        if (nav) nav.classList.add('swiper-nav--locked');
      });

      slider.on('unlock', () => {
        const nav = slider.el.querySelector('.swiper-nav');
        if (nav) nav.classList.remove('swiper-nav--locked');
      });
    });
  }, 50);
}

// Swiper Slider - Product Page
if (document.querySelector('.swiper--product-images')) {
  const productThumbsSwiper = new Swiper('.swiper--product-thumbs', {
    slidesPerView: 8,
    direction: 'vertical',
    spaceBetween: 14,
  });

  productThumbsSwiper.on('click', () => {
    const clicked = productThumbsSwiper.clickedIndex;
    const first   = productThumbsSwiper.activeIndex;
    const last    = first + productThumbsSwiper.params.slidesPerView - 1;

    if (clicked === last) {
      productThumbsSwiper.slideTo(first + 1);
    } else if (clicked === first && first > 0) {
      productThumbsSwiper.slideTo(first - 1);
    }
  });

  productImagesSwiper = new Swiper('.swiper--product-images', {
    pagination: {
      el: '.swiper-pagination--product-images',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next--product-images',
      prevEl: '.swiper-button-prev--product-images',
    },
    thumbs: {
      swiper: productThumbsSwiper,
    },
  });
}

/******************************************
VANILLA JS - THEME EDITOR
******************************************/

// Theme Editor
document.addEventListener("shopify:section:load", function(event) {
  register();
});

/******************************************
VANILLA JS - THIRD PARTY CLEAN UPS
******************************************/
// Prevent Font Awesome Load from 3rd Party
const appendElementBackup = Element.prototype.appendChild;
Element.prototype.appendChild = function(...args) {
  if (args[0].nodeName && args[0].nodeName == 'SCRIPT' && args[0].src.indexOf('jquery.min.js') != -1) {
    if (window.SPR != undefined) {
      SPR.loadjQueryExtentions(jQuery);
      document.addEventListener('DOMContentLoaded', function () {
        SPR.$ = jQuery;
        SPR.registerCallbacks();
        SPR.initRatingHandler();
        SPR.initDomEls();
        SPR.loadProducts();
        SPR.loadBadges();
      });
    }
    return;
  }
  if (!args[0].outerHTML || (args[0].outerHTML && args[0].outerHTML.indexOf("maxcdn.bootstrapcdn.com/font-awesome/4.6.3/css/font-awesome.min.css") == -1))
    return appendElementBackup.apply(this, args);
};
const faLink = document.querySelector('link[href="https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css"]');
if (faLink) faLink.remove();

/******************************************
VANILLA JS - VIDEO
******************************************/
// Video - General Play and Pause
const vids = document.querySelectorAll('video');

vids.forEach(vid => {
  vid.controls = false;

  vid.addEventListener('click', function () {
    this.paused ? this.play() : this.pause();
  });

  vid.addEventListener('pause', function () {
    console.log('stopped');
    this.parentElement.classList.remove('responsive-video--stopped');
  });

  vid.addEventListener('play', function () {
    console.log('playing');
    this.parentElement.classList.add('responsive-video--stopped');
  });
});

// Video Delayed (On Mousemove) - Hero Text Banner
var videoPlayer = document.getElementById('vbanner');
if(videoPlayer){
  window.afterLoadWithEvents.push(
  {
     f:'_loadVideo',
     evt:'mousemove',
     el: document
   }
  ); 
  function _loadVideo() {
    // Video
    var valSources = document.querySelectorAll('video#vbanner source'),
    valVideo = document.querySelector('video#vbanner'),
    valDataSrc = 'data-src',
    valDataPoster = 'data-poster';

    if(window.innerWidth < 601 ) {
      valDataSrc = 'data-src-mobile';
      valDataPoster = 'data-poster-mobile';
    }

    for(var i = 0; i<valSources.length;i++) {
      valSources[i].setAttribute('src',       valSources[i].getAttribute(valDataSrc) || '');
    }

    valVideo.load();

    videoPlayer.addEventListener("canplaythrough", function() {
      videoPlayer.play();
    });
  }
}

// Video AutoPlay - Hero Text Banner
var videoAuto = document.getElementById('vbannerauto');
if(videoAuto){
  // Video
  var valSources = document.querySelectorAll('video#vbannerauto source'),
  valVideo = document.querySelector('video#vbannerauto'),
  valDataSrc = 'data-src',
  valDataPoster = 'data-poster';

  if(window.innerWidth < 601 ) {
    valDataSrc = 'data-src-mobile';
    valDataPoster = 'data-poster-mobile';
  }

  for(var i = 0; i<valSources.length;i++) {
    valSources[i].setAttribute('src',       valSources[i].getAttribute(valDataSrc) || '');
  }

  valVideo.load();

  videoAuto.addEventListener("canplaythrough", function() {
    videoAuto.play();
  });
}

// Floating Add to Basket Button
function initFloatingAddToBasket() {
  const floatingButton = document.getElementById('floating-add-to-basket');
  const originalButton = document.getElementById('add-to-cart');
  const floatingAddButton = document.getElementById('floating-add-to-cart');
  const originalQuantityInput = document.querySelector('[data-quantity-input]');
  const floatingQuantityInput = document.querySelector('[data-floating-quantity-input]');
  const floatingPriceElement = document.getElementById('floating-add-to-basket-price');
  const priceElement = document.querySelector('.product-price');
  
  if (!floatingButton || !originalButton) return;

  // Sync quantity between buttons
  const syncQuantity = () => {
    if (originalQuantityInput && floatingQuantityInput) {
      floatingQuantityInput.value = originalQuantityInput.value;
    }
  };

  // Sync price
  const syncPrice = () => {
    if (priceElement && floatingPriceElement) {
      const priceText = priceElement.querySelector('.product-price__standard')?.textContent || priceElement.textContent;
      floatingPriceElement.textContent = priceText;
    }
  };

  // Sync button state and variant ID
  const syncButtonState = () => {
    if (originalButton && floatingAddButton) {
      floatingAddButton.textContent = originalButton.textContent;
      floatingAddButton.disabled = originalButton.disabled;
      floatingAddButton.dataset.variantId = originalButton.dataset.variantId;
    }
    syncPrice();
  };

  // Update floating quantity when original changes
  if (originalQuantityInput) {
    originalQuantityInput.addEventListener('change', syncQuantity);
  }

  // Floating quantity controls
  document.querySelectorAll('.floating-add-to-basket__quantity-add').forEach(btn => {
    btn.addEventListener('click', () => {
      if (floatingQuantityInput) {
        floatingQuantityInput.value = Math.max(1, parseInt(floatingQuantityInput.value || 1) + 1);
        if (originalQuantityInput) {
          originalQuantityInput.value = floatingQuantityInput.value;
          originalQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  });

  document.querySelectorAll('.floating-add-to-basket__quantity-minus').forEach(btn => {
    btn.addEventListener('click', () => {
      if (floatingQuantityInput) {
        floatingQuantityInput.value = Math.max(1, parseInt(floatingQuantityInput.value || 1) - 1);
        if (originalQuantityInput) {
          originalQuantityInput.value = floatingQuantityInput.value;
          originalQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  });

  // Scroll detection to show/hide floating button
  const mobileMediaQuery = window.matchMedia('(max-width: 749px)');
 
const handleScroll = () => {
  if (!originalButton) return;
 
  const rect = originalButton.getBoundingClientRect();
  const shouldShow = mobileMediaQuery.matches
    ? rect.bottom < 0   // mobile: wait until the whole button has cleared
    : rect.top < 0;     // desktop: original behaviour, unchanged
 
  if (shouldShow) {
    floatingButton.style.display = 'flex';
    syncButtonState();
    syncQuantity();
  } else {
    floatingButton.style.display = 'none';
  }
};
 
window.addEventListener('scroll', handleScroll, { passive: true });
 
// Re-evaluate on resize/orientation change too, since crossing the
// 749px breakpoint changes which rule applies even without a scroll.
window.addEventListener('resize', handleScroll, { passive: true });
  
  // Initial sync
  syncQuantity();
  syncButtonState();
  handleScroll();

  // Sync when original button state changes
  const observer = new MutationObserver(() => {
    syncButtonState();
  });
  
  observer.observe(originalButton, {
    attributes: true,
    attributeFilter: ['disabled', 'data-variant-id'],
    characterData: false,
    childList: true,
    subtree: true
  });

  // Add click handler to floating button (copy functionality from original)
  if (floatingAddButton) {
    floatingAddButton.addEventListener('click', () => {
      const originalQuantityHidden = document.querySelector('[data-quantity-hidden]');
      if (floatingQuantityInput && originalQuantityHidden) {
        originalQuantityHidden.value = floatingQuantityInput.value;
      }
      originalButton.click();
    });
  }
}

// Initialize floating button when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFloatingAddToBasket);
} else {
  initFloatingAddToBasket();
}

// Featured Collection - Tabs
document.querySelectorAll('.featured-collection-tabs__tab').forEach(tabEl => {
  tabEl.addEventListener('click', function () {
    const tab = this.dataset.tab;

    document.querySelectorAll('.featured-collection-tabs__tab')
      .forEach(el => el.classList.remove('featured-collection-tabs__tab--active'));

    document.querySelectorAll('.featured-collection-tabs__tab-content')
      .forEach(el => el.classList.remove('featured-collection-tabs__tab-content--active'));

    this.classList.add('featured-collection-tabs__tab--active');

    const target = document.getElementById(tab);
    if (target) {
      target.classList.add('featured-collection-tabs__tab-content--active');
    }
  });
});